import CodeInput from "./CodeInput";

export default CodeInput;